import {Field, FIELD_TYPES, Model} from '../../vue-ocom/schema';

export default Model('code_time_of_day', {
  verbose_name: "Time Of Day",
  verbose_name_plural: "Time Of Day",
  fields: [
    Field('id', {label: 'ID', primary_key: true, readonly: true, hide: false, field_type: FIELD_TYPES.AutoNumber}),

    Field('code', {
      label: "Code",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return null;
      }
    }),
    Field('description', {
      label: "Description",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return '';
      }
    }),
    Field('active_start_date', {
      label: "Active Start Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      }
    }),
    Field('active_end_date', {
      label: "Active End Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      }
    }),
    Field('created_date', {
      label: "Created Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      }
    }),
    Field('modified_date', {
      label: "Modified Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      }
    }),
  ]
});
